/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CommentTagType } from './CommentTagType';
import {
    CommentTagTypeFromJSON,
    CommentTagTypeFromJSONTyped,
    CommentTagTypeToJSON,
} from './CommentTagType';
import type { EntityWithCommentType } from './EntityWithCommentType';
import {
    EntityWithCommentTypeFromJSON,
    EntityWithCommentTypeFromJSONTyped,
    EntityWithCommentTypeToJSON,
} from './EntityWithCommentType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';

/**
 * 
 * @export
 * @interface PtwCommentDto
 */
export interface PtwCommentDto {
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwCommentDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PtwCommentDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    entityId?: string | null;
    /**
     * 
     * @type {EntityWithCommentType}
     * @memberof PtwCommentDto
     */
    entityType?: EntityWithCommentType;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof PtwCommentDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof PtwCommentDto
     */
    lastModifierUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof PtwCommentDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof PtwCommentDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {Array<CommentTagType>}
     * @memberof PtwCommentDto
     */
    tags?: Array<CommentTagType> | null;
    /**
     * 
     * @type {string}
     * @memberof PtwCommentDto
     */
    $type?: PtwCommentDtoTypeEnum;
}


/**
 * @export
 */
export const PtwCommentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoCommentsPtwCommentDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Comments.PtwCommentDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwCommentDtoTypeEnum = typeof PtwCommentDtoTypeEnum[keyof typeof PtwCommentDtoTypeEnum];


/**
 * Check if a given object implements the PtwCommentDto interface.
 */
export function instanceOfPtwCommentDto(value?: unknown): value is PtwCommentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwCommentDtoTypeEnum)[0];
}

export function PtwCommentDtoFromJSON(json: any): PtwCommentDto {
    return PtwCommentDtoFromJSONTyped(json, false);
}

export function PtwCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwCommentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'entityType': !exists(json, 'entityType') ? undefined : EntityWithCommentTypeFromJSON(json['entityType']),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : HistoryDtoUserFromJSON(json['lastModifierUser']),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'] === null ? null : (json['tags'] as Array<any>).map(CommentTagTypeFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function PtwCommentDtoToJSON(value?: PtwCommentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'description': value.description,
        'entityId': value.entityId,
        'entityType': EntityWithCommentTypeToJSON(value.entityType),
        'creatorUser': HistoryDtoUserToJSON(value.creatorUser),
        'lastModifierUser': HistoryDtoUserToJSON(value.lastModifierUser),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'possibleActions': value.possibleActions === undefined ? undefined : (value.possibleActions === null ? null : (value.possibleActions as Array<any>).map(PossibleActionDtoToJSON)),
        'tags': value.tags === undefined ? undefined : (value.tags === null ? null : (value.tags as Array<any>).map(CommentTagTypeToJSON)),
        '$type': value.$type,
    });
}

